<template>
  <div class="base-table">
    <div class="table-head">
      <div class="head-cell"
           v-for="(col, colIndex) in tableCols"
           :key="'headcol'+colIndex"
           :class="col.colClass"
           :style="{flexBasis: col.width || normalCellWidth}">
        {{ col.label }}
      </div>
    </div>
    <template v-if="tableData.length">
      <div class="table-row" v-for="(row, rowIndex) in tableData" :key="'row'+rowIndex">
        <div v-for="(col, colIndex) in tableCols"
             :key="'col'+rowIndex+colIndex"
             class="table-cell"
             :class="col.colClass"
             :style="{flexBasis: col.width || normalCellWidth}">
          <p class="col-title">{{ col.label }}</p>
          <slot :name="col.slot" v-bind="prepareTableData(row, col, rowIndex, colIndex)">
            <p v-html="col.formatter && typeof col.formatter === 'function' ? col.formatter(row[col.key]) : row[col.key]"></p>
          </slot>
        </div>
      </div>
    </template>
    <template v-else>
      <slot name="no-content"></slot>
    </template>
  </div>
</template>

<script>
export default {
  name: 'base-table',
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    columns: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  filters: {
    humanizeString (val) {
      if (!val || typeof val !== 'string') return ''
      return val
        .replace(/^[\s_]+|[\s_]+$/g, '')
        .replace(/[_\s]+/g, ' ')
        .replace(/^[a-z]/, (str) => {
          return str.toUpperCase()
        })
        .replace(/[\w][A-Z]/g, (str) => {
          return `${str[0]} ${str[1]}`
        })
        .replace(/\s[a-z]/, (str) => {
          return str.toUpperCase()
        })
    }
  },
  computed: {
    tableData () {
      return this.$props.data
    },
    tableCols () {
      if (this.$props.columns.length) {
        const fields = this.$props.columns
        if (fields[0].label) {
          return fields
        }
        return fields.map(field => {
          return {
            key: field,
            label: this.$options.filters.humanizeString(field),
            slot: field.slot
          }
        })
      }

      if (Object.keys(this.$props.data).length) {
        const headerKeys = Object.keys(this.$props.data[0])
        return headerKeys.map(key => {
          return {
            key: key,
            label: this.$options.filters.humanizeString(key)
          }
        })
      }
      return []
    },
    normalCellWidth () {
      return this.tableCols.length ? Math.round(100 / this.tableCols.length) + '%' : null
    }
  },
  methods: {
    prepareTableData (rowData, columnData, rowIndex, colIndex) {
      const colData = []
      this.$props.data.forEach(row => {
        for (const prop in row) {
          if (prop === columnData.key) {
            colData.push(row[prop])
          }
        }
      })
      const cellData = rowData[columnData.key]
      return {
        rowData,
        colData,
        rowIndex,
        colIndex,
        cellData
      }
    }
  }
}
</script>

<style scoped lang="scss" src="./styles/_base-table.scss"></style>
